import mixitup from 'mixitup';

$(() => {
  // Mobile Nav
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#nav-primary-toggle').click(function() {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });

  // Desktop Nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
    if( $(window).innerWidth() > 991 ) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element){
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });

  // FAQs
  $('.pfFaq').on('click', function() {
    if(!$('.' + $(this).data('faq')).hasClass('pfActive')) {
      $('.pfActive').removeClass('pfActive');
      $('.' + $(this).data('faq')).addClass('pfActive');
    }
  })

  // Product Brochures & Downloads
  $('.pbdButton').on('click', function() {
    if(!$('.' + $(this).data('pbd')).hasClass('pbdActive')) {
      $('.pbdActive').removeClass('pbdActive');
      $('.' + $(this).data('pbd')).addClass('pbdActive');
      $(this).addClass('pbdActive');
    }
  })

  // Sticky CTA
  $(window).on('scroll', function() {
    if ($(document).scrollTop() > 300) {
      $('.fixed-side').addClass('fixed-side-show');
    } else {
      $('.fixed-side').removeClass('fixed-side-show');
    }

    if ($(document).scrollTop() > 350) {
      $('.fixed-side').addClass('fixed-desktop');
    } else {
      $('.fixed-side').removeClass('fixed-desktop');
    }
  });

  // Button Scroll
  $('.btn-scroll').on('click', function() {
    if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 200,
        }, 1000);
        return false;
      }
    }
  });

  // Mixitup
  if( $('.mix-container').length ) {
    var mixer = mixitup('.mix-container');
    if(mixer) {
      console.log('mix');
    }
  }

  if( $('.product_showcase_mix').length ) {
    var mixer = mixitup('.product_showcase_mix', {
      load: {
        filter: '.windows'
      }
    });
    if(mixer) {
      console.log('mix');
    }
  }

  // Cookie Policy
  $.fn.CookieNotice = function() {
    if (!localStorage.getItem('cookie-notice-dismissed')) {
      var notice = this;
      setTimeout(function() {
        notice.addClass('active');
      }, 1000);
    }
    this.addClass('cookie-notice');
    return this
  }
  $(document).on('click', '.cookie-notice-dismiss', function() {
    localStorage.setItem('cookie-notice-dismissed', true);
    $(this).parents('.cookie-notice').removeClass('active');
  })
  $('#cookie-notice').CookieNotice();

  // Share Button
  $('.page-share').click(function() {
    if( navigator.share ) {
      navigator.share({
        title: 'Share This Page',
        url: window.location,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(err => {
        console.log('Couldnt share because of', err.message);
      });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!')
    }
  });

  $('.panel-share-close').click(function() {
    $('#panel-share').removeClass('active');
  });

  // Slick
  $('.slick-banner').on('init', function() {
    var hiddenSlides = $('.slick-banner .hidden');
    if(hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function(i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  $('.slick-banner').slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.slick-p').click(function() {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function() {
    $(this).parent().prev().slick('slickNext');
  });

  $('.slick-testimonials').slick({
    dots: true,
    arrows: false,
    prevArrow: '.stLeft',
    nextArrow: '.stRight',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    adaptiveHeight: true,
  });

  $('.slick_case_studies').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
  });


  $('.callback-form .form-pane-option').click(function() {
    $('.callback-form .form-pane-option').removeClass('active');
    $(this).addClass('active');
    $('.pane-option-response').text('');
  });

  $('.callback-form .form-pane-submit').click(function() {

    var name = $('.callback-form .form-pane-option.active').data('name');
    var value = $('.callback-form .form-pane-option.active').data('value');
    var pane = null;
    if( $('.callback-form .form-pane-option.active').data('pane') ) {
      pane = $('.callback-form .form-pane-option.active').data('pane');
    }

      nextPane(pane)

  });

  $('.validate-postcode').click(function() {

    var $this = $(this);
    var $response = $('.postcode-response');
    var $postcode = $('.postcode-input').val();

    $this.prop('disabled', true);
    $response.empty();
    $('.postcode-input').removeClass('border-red');

    $.ajax({
      url: '//api.postcodes.io/postcodes/' + $postcode,
      method: 'get'
    }).done(function(response) {
      $postcode = response.result.postcode;
      nextPane();
    }).fail(function(response) {
      $('.postcode-input').addClass('border-red');
      $response.text('Please enter a valid UK postcode.');
      $this.prop('disabled', false);
    });

  });
  // call back form
  function nextPane(pane) {

    var $form = $('.callback-form');
    var $active = $form.find('.form-pane.active');
    var $next = $active.next();
    var $increment = 1;

    if( pane != null ) {
      $next = $form.find('.form-pane').eq(pane);
      $increment = pane - $active.index();
    }

    console.log($active.index());

    var $activeIndex = $active.index() + 1;


    $active.removeClass('active');
    $next.addClass('active');

  };

  

});
